module.exports = __webpack_public_path__ + "img/671.5269cde4.png";